import React from 'react';
import styled from 'styled-components';
import colors from '../../../constants/colors';

const TabsEl = styled.div`
  margin: 0 auto;
  width: 100%;

  @media only screen and (min-width: 768px) {
    width: 500px;
  }
`;

const TitlesContainer = styled.span`
  display: flex;
  justify-content: space-around;
  margin: 0 1.5rem;
  padding: 0 1rem;
`;

const Title = styled.span`
  padding: 0.5rem 0;
  cursor: pointer;
  position: relative;
  text-transform: uppercase;
  ${p => (p.active ? `color:${colors.white_f2};` : `color:${colors.gray_66};`)};
  ${p => `font-weight:500;`};
  
  :first-child {
    padding-right: 16px;
  }

  @media only screen and (min-width: 768px) {  
    padding-right: 0
  }
}

  ::after {
    ${p => (!p.active ? 'display:none;' : '')}
    content: "";
    position: absolute;
    left: 0;
    bottom: -8px;
    width: 40px;
    margin-left: 50%;
    transform: translateX(-50%);
    height: 2px;
    ${p => `background-color:${colors.gray_aa};`};
`;

export default function Tabs({ tabs, currentTab, setCurrentTab }) {
  return (
    <TabsEl>
      <TitlesContainer>
        {tabs?.map((tab, index) => {
          return (
            <Title
              onClick={() => {
                if (currentTab?.id !== tab.id) {
                  setCurrentTab(tab);
                }
              }}
              active={currentTab?.id === tab.id}
              key={index}
            >
              {tab?.title}
            </Title>
          );
        })}
      </TitlesContainer>
    </TabsEl>
  );
}
